import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/Production/Form/NewBuildingDailyInspectionReport/'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import {
    v2_projects,
    v2_ships,
} from '../../../actions/v2/projectAndVessel';
import {
    v3_fetchNewBuildingDailyInspectionReport,
    v3_submitNewBuildingDailyInspectionReport,

} from '../../../actions/v3/productionForm';
import Swal from 'sweetalert2';

const NewBuildingDailyInspectionReport = (props) => {

    const location = useLocation();
    const { data } = location.state || {};
    // 1. Rename state to items (flat list)
    const defaultRow = {
        date: { name: 'date', value: '', error: '', isRequired: true },
        inspection_area: { name: 'inspection_area', value: '', error: '', isRequired: true },
        inspection_item: { name: 'inspection_item', value: '', error: '', isRequired: true },
        type_of_inspection: { name: 'type_of_inspection', value: '', error: '', isRequired: true },
        comment_and_remark: { name: 'comment_and_remark', value: '', error: '', isRequired: true },
        result: { name: 'result', value: '', error: '', isRequired: true },

    };

    const [state, setState] = useState([defaultRow]);
    const handleChange = (field, value, index = 0) => {
        setState(prevState => {
            const updatedState = [...prevState];
            updatedState[index][field] = {
                ...updatedState[index][field],
                value,
                error: '',
            };
            return updatedState;
        });
    };

    const addRow = () => {
        setState(prev => [...prev, JSON.parse(JSON.stringify(defaultRow))]);
    };

    const removeRow = (indexToRemove) => {
        setState(prev => prev.filter((_, i) => i !== indexToRemove));
    };

    const [commonDetails, setCommonDetails] = useState({
        project: { value: '', options: [], error: '' },
        ship: { value: '', options: [], error: '' },
        date: { value: '', error: '' },
        finalSubmit: { value: false },
    });

    const [showLoader, setShowLoader] = useState(false);

    // Load projects
    useEffect(() => {
        v2_projects().then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    project: { ...prev.project, options: res.result },
                }));
            }
        });
    }, []);

    // Load ships when project changes
    useEffect(() => {
        if (commonDetails.project.value) {
            v2_ships(null, commonDetails.project.value).then((res) => {
                if (res.status) {
                    setCommonDetails((prev) => ({
                        ...prev,
                        ship: { ...prev.ship, options: res.result },
                    }));
                }
            });
        } else {
            setCommonDetails((prev) => ({
                ...prev,
                ship: { value: '', options: [] },
            }));
        }
    }, [commonDetails.project.value]);

    useEffect(() => {
        const params = data ? JSON.parse(atob(data)) : null;
        if (params) {
            setShowLoader(true);

            v3_fetchNewBuildingDailyInspectionReport(
                params.PROJECT_ID,
                params.SHIP_ID
            )
                .then((res) => {
                    if (res.status) {
                        const { commonDetails, records = [] } = res.result;

                        // set common details if editing
                        if (params.PROJECT_ID) {
                            setCommonDetails((prev) => ({
                                ...prev,
                                project: { ...prev.project, value: commonDetails?.PROJECT_ID || '' },
                                ship: { ...prev.ship, value: commonDetails?.SHIP_ID || '' },
                                date: { ...prev.date, value: commonDetails?.SUBMISSION_DATE || '' },
                                finalSubmit: { value: Boolean(commonDetails?.FINAL_SUBMITTED) },

                            }));
                        }

                        // convert flat records to form model
                        const mappedItems = records.map((item) => {
                            return {
                                entryId: item.ID,
                                date: {
                                    ...defaultRow.date,
                                    value: item.DATE || '',
                                },
                                inspection_area: {
                                    ...defaultRow.date,
                                    value: item.INSPECTION_AREA || '',
                                }, inspection_item: {
                                    ...defaultRow.date,
                                    value: item.INSPECTION_ITEM || '',
                                }, type_of_inspection: {
                                    ...defaultRow.date,
                                    value: item.TYPE_OF_INSPECTION || '',
                                }, comment_and_remark: {
                                    ...defaultRow.date,
                                    value: item.COMMENT_AND_REMARK || '',
                                }, result: {
                                    ...defaultRow.date,
                                    value: item.RESULT || '',
                                },
                            };
                        });

                        // set state (renamed from state to items if needed)
                        setState(mappedItems);
                    } else {
                        toast.error(res.error);
                    }
                })
                .catch(() => toast.error('Something went wrong while fetching.'))
                .finally(() => setShowLoader(false));
        }

    }, []);

    const onSubmit = async () => {
        // 1. Validation
        const errors = [];
        if (!commonDetails.project.value) errors.push('Select a project.');
        if (!commonDetails.ship.value) errors.push('Select a ship.');
        
        // Validate each row
        state.forEach((row, index) => {
            Object.entries(row).forEach(([key, field]) => {
                if (key === 'entryId') return; // Skip entryId

                const isRequired = field.isRequired || commonDetails.finalSubmit.value; // Enforce all fields if finalSubmit is true
                if (isRequired && !field.value) {
                    errors.push(`Row ${index + 1}: ${key.replace(/_/g, ' ')} is required.`);
                }
            });
        });


        if (errors.length > 0) {
            toast.error(
                <div>
                    {errors.map((err, i) => (
                        <div key={i}>{err}</div>
                    ))}
                </div>
            );
            return;
        }

        // If final submit is true, confirm before proceeding
        if (commonDetails.finalSubmit.value) {
            const confirmResult = await Swal.fire({
                title: 'Are you sure?',
                text: 'Do you want to submit the reports for Office Review?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it',
                cancelButtonText: 'Cancel',
            });

            if (!confirmResult.isConfirmed) return;
        }

        // 2. Build checklistItems payload
        const checklistItems = state.map((row) => {
            const formattedRow = {};
            Object.keys(row).forEach((key) => {
                formattedRow[key.toUpperCase()] = row[key].value;
            });
            if (row['entryId']) {
                formattedRow.ID = row['entryId']
            }
            return formattedRow;
        });

        // 3. Build full payload
        const payload = {
            commonDetails: {
                project: commonDetails.project.value,
                ship: commonDetails.ship.value,
                date: commonDetails.date.value,
                finalSubmit: commonDetails.finalSubmit.value,

            },
            checklistItems,
        };

        // 4. Submit
        setShowLoader(true);
        v3_submitNewBuildingDailyInspectionReport(payload)
            .then((res) => {
                setShowLoader(false);
                if (res.status) {
                    toast.success(res.result.message || 'Submitted successfully!');
                    props.history.push(constant.Authedcomponent.submittedNewBuildingDailyInspectionReport.url);
                } else {
                    toast.error(res.error || 'Submission failed.');
                }
            })
            .catch((err) => {
                setShowLoader(false);
                toast.error('Submission failed.');
                console.error('Submit Error:', err);
            });
    };
    useEffect(() => {
        const selected = commonDetails.ship.options.find(
            (i) => i.ID == commonDetails.ship.value
        );

        if (selected) {
            setCommonDetails((prev) => ({
                ...prev,
                yard: {
                    ...prev.yard,
                    value: selected.YARD_NAME || ''
                }
            }));
        }
    }, [commonDetails.ship.value, commonDetails.ship.options]);


    return (
        <Layout title="Daily Inspection Report">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="checklist-title-bx">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="text-center">
                                            <h4>DAILY INSPECTION REPORT</h4>
                                            <p>
                                                Following to be checked and confirmed before official delivery of the vessel


                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="report-index-top">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="hd-s2 pl10">
                                                        <p>Project</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <select
                                                            className="form-select"
                                                            value={commonDetails.project.value}
                                                            disabled={data ? true : false}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    project: { ...prev.project, value: e.target.value },
                                                                }))
                                                            }
                                                        >

                                                            <option value={''}>Select Project</option>
                                                            {commonDetails.project.options.map((item) => {
                                                                return (<option value={item.ID}>{item.PROJECT_CODE} - {item.PROJECT_NAME}</option>)
                                                            })}
                                                        </select>
                                                    </td>

                                                    <td className="hd-s2 pl10">
                                                        <p>Hull</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <select
                                                            className="form-select"
                                                            disabled={data ? true : false}
                                                            value={commonDetails.ship.value}
                                                            onChange={(e) => {
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    ship: { ...prev.ship, value: e.target.value }
                                                                }));
                                                            }}


                                                        >

                                                            <option value={''}>Select Hull</option>
                                                            {commonDetails.ship.options.map((item) => {
                                                                return (<option value={item.ID}>{item.HULL_NUMBER} - {item.SHIP_NAME}</option>)
                                                            })}
                                                        </select>
                                                    </td>
                                                    <td className="hd-s2 pl10">
                                                        <p>Owner</p>
                                                    </td>
                                                    <td className="">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={commonDetails.ship.options.find((item) => item.ID == commonDetails.ship.value)?.OWNER_NAME}
                                                            disabled
                                                            placeholder='Autofill'
                                                        />
                                                    </td>
                                                    <td className="hd-s2 pl10">
                                                        <p>Yard</p>
                                                    </td>
                                                    <td className="">
                                                        <input
                                                            className="form-control"
                                                            type='text'
                                                            value={commonDetails.ship.options.find((item) => item.ID == commonDetails.ship.value)?.YARD_NAME}
                                                            placeholder='Autofill'
                                                            disabled
                                                        />


                                                    </td>



                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="about-inspection-report">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="hd-s2">
                                                        <p>Remark:</p>
                                                    </td>
                                                    <td className="hd-s2">
                                                        <p>
                                                            <span>AA</span>: Accepted
                                                        </p>
                                                    </td>
                                                    <td className="hd-s2">
                                                        <p>
                                                            <span>QCC</span>: to be confirmed by Q.A
                                                        </p>
                                                    </td>
                                                    <td className="hd-s2">
                                                        <p>
                                                            <span>OWC</span>: to be confirmed by Owner
                                                        </p>
                                                    </td>
                                                    <td className="hd-s2">
                                                        <p>
                                                            <span>PP</span>: Pending
                                                        </p>
                                                    </td>
                                                    <td className="hd-s2">
                                                        <p>
                                                            <span>NA</span>: Rejected
                                                        </p>
                                                    </td>
                                                    <td className="hd-s2">
                                                        <p>
                                                            <span>CXL</span>: Cancelled
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <Form
                                onChange={handleChange}
                                state={state}
                                onSubmit={onSubmit}
                                addRow={addRow}
                                isFinalSubmitting={commonDetails.finalSubmit.value}
                                setIsFinalSubmitting={() => setCommonDetails((prev) => ({
                                    ...prev,
                                    finalSubmit: { ...prev.finalSubmit, value: !commonDetails.finalSubmit.value },
                                }))}
                            />


                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default NewBuildingDailyInspectionReport